module.exports = ["外幣","美金","日幣","通貨膨脹","自動櫃員機","道瓊工業指數","三大法人","數位支付","熱錢","精算師","套牢","擠兌","貶值","贖回","交割","零股","面值","洗錢","銀根","頭寸","透支","大盤","牛市","多頭","行動科技","開放資料","搜尋引擎","大數據","區塊鏈","去中心化","加密貨幣","比特幣","匿名化","雲端運算","資料庫","人工智慧","深度學習","使用者體驗","物聯網","演算法","新創公司","孵化器","加速器","天使投資人","群眾募資","共享辦公室","虛擬實境","擴增實境","混合實境","跨境電商","法人","標準差","直效行銷","躉繳","連續競價","去槓桿化","槓桿交易","滯脹","二級市場","次級市場","集中市場","現貨市場","影子銀行","鍋爐室騙局","綠皮書","授信","回檔","盤整","空殼公司","借殼上市","公債","衍生性金融商品","指數型基金","權證","選擇權","次級房貸","保本基金","交叉持股","複利","毛利率","殖利率","投資報酬率","折現率"]


//////////////////
// WEBPACK FOOTER
// ./src/Ogilvy/主題/金融尬台語.json
// module id = 864
// module chunks = 0